/**
 * Copyright (c) 2022-present TVM Engineering Authors.
 *
 */

import axios from "axios";

import { errorHandler, options } from "./index";
import { API_URL } from "../config";
import types from "../actions/types";
import IsUserUnauthorized from "../utils/unauthorized";
import { toast_notifications } from "../utils/notifications";

export function fetchInviteUser(body) {
  return async (dispatch) => {
    try {
      const response = await axios(options(API_URL + "/admin/user/invite", body));
      const responseOK = response && response.status === 200 && response.statusText === "OK";
      if (responseOK) {
        const data = await response.data;
        dispatch({
          type: types.INVITE_USER,
          payload: data.data,
        });
      }
    } catch (error) {
      console.warn("Error:", error);
      dispatch(errorHandler(error));
    }
  };
}

export function fetchAllUsers(method = "get") {
  return async (dispatch) => {
    try {
      const response = await axios(options(API_URL + "/admin/users", {}, method)).catch((error) => {
        if (error.response) {
          const status = error?.response?.status;
          IsUserUnauthorized(status);
        }
      });
      const responseOK = response && response.status === 200 && response.statusText === "OK";
      if (responseOK) {
        await dispatch({
          type: types.FETCH_ALL_USERS,
          payload: response.data,
        });
      }
    } catch (error) {
      console.warn("Error:", error);
      await dispatch(errorHandler(error));
    }
  };
}

export function fetchUser(method, body, status) {
  return async (dispatch) => {
    let q = "";
    if (method === "delete") {
      q = "remove";
    } else if (method === "put" && status === "updateUserRole") {
      q = "role";
    } else if (method === "put" && status === "updateUser") {
      q = "edit";
    }
    try {
      const URL = API_URL + "/admin/" + q;
      const response = await axios(options(URL, body, method));
      const responseOK = response && response.status === 200 && response.statusText === "OK";
      let data;
      if (responseOK) {
        data = await response.data;
        // console.log("fetchUser::", data);
      }
      if (method === "put" && status === "updateUserRole") {
        dispatch({
          type: types.SET_USER_ROLE,
          payload: data.data, // json.user,
        });
        toast_notifications.success("Successfully updated user role!");
      }
      if (method === "put" && status === "updateUser") {
        dispatch({
          type: types.UPDATE_USER,
          payload: data.data, // json.user,
        });
        toast_notifications.success("Successfully updated user role!");
      } else if (method === "delete") {
        dispatch({
          type: types.REMOVE_USER,
          payload: data.data, // json.user,
        });
        toast_notifications.success("Successfully deleted user!");
      } else {
        dispatch({
          type: types.GET_USER,
          payload: data.data, // json.user,
        });
      }
    } catch (error) {
      dispatch(errorHandler(error));
    }
  };
}

export function fetchCreateUser(body) {
  return async (dispatch) => {
    try {
      const response = await axios(options(API_URL + "/admin/user_create", body, "post"));
      const responseOK = response && response.status === 200 && response.statusText === "OK";
      if (responseOK) {
        dispatch({
          type: types.FETCH_CREATE_USER,
          payload: response.data, // json.user,
        });
        toast_notifications.success("Successfully created user!");
      }
    } catch (error) {
      console.warn("Error:", error);
      dispatch(errorHandler(error));
    }
  };
}

export function fetchUserActivation(data) {
  return async (dispatch) => {
    try {
      const response = await axios(options(API_URL + "/admin/user_activation", data, "put"));
      const responseOK = response && response.status === 200 && response.statusText === "OK";
      if (responseOK) {
        const res = response.data;
        dispatch({
          type: types.FETCH_USER_ACTIVATION,
          activated: res.activated,
        });

        dispatch({
          type: types.FETCH_ALL_USERS,
          payload: res.data,
        });
        const severity = res.activated === true ? "success" : "info";
        if (severity === "info") {
          toast_notifications.success("User is deactivated successfully!");
        } else {
          toast_notifications.success("User is activated successfully!");
        }
      }
    } catch (error) {
      console.warn("Error:", error);
      dispatch(errorHandler(error));
    }
  };
}

export function deleteUser(body) {
  return async (dispatch) => {
    try {
      const response = await axios(options(API_URL + "/admin/deleteUser", body, "post"));
      const responseOK = response && response.status === 200 && response.statusText === "OK";
      if (responseOK) {
        toast_notifications.success("Successfully deleted user!");
      }
    } catch (error) {
      console.warn("Error:", error);
      dispatch(errorHandler(error));
    }
  };
}

export function fetUserInitialProjectStatus(data) {
  return async (dispatch) => {
    try {
      const response = await axios(
        options(API_URL + "/admin/updateInitialProjectStatus", data, "post")
      );
      const responseOK = response && response.status === 200 && response.statusText === "OK";
      if (responseOK) {
        toast_notifications.success("Successfully deleted user!");
      }
    } catch (error) {
      console.warn("Error:", error);
      dispatch(errorHandler(error));
    }
  };
}

export function updateUserRole(data) {
  return async (dispatch) => {
    try {
      const response = await axios(options(API_URL + "/admin/role", { data }, "put"));
      const responseOK = response && response.status === 200 && response.statusText === "OK";
      if (responseOK) {
        toast_notifications.success("User role successfully updated!");
      }
    } catch (error) {
      console.warn("Error:", error);
      dispatch(errorHandler(error));
    }
  };
}

// This is part from the new role functionality
export function createUserRole(data) {
  return async (dispatch) => {
    try {
      const response = await axios(options(API_URL + "/admin/role", data, "post"));
      const responseOK = response && response.status === 200 && response.statusText === "OK";
      if (responseOK) {
        toast_notifications.success("User role successfully created!");
      }
    } catch (error) {
      console.warn("Error:", error);
      dispatch(errorHandler(error));
    }
  };
}

export function getAllRoles() {
  return async (dispatch) => {
    try {
      const response = await axios(options(API_URL + "/roles/getAll", {}, "get"));
      const responseOK = response && response.status === 200 && response.statusText === "OK";
      if (responseOK) {
        return response.data;
      }
    } catch (error) {
      console.warn("Error:", error);
      dispatch(errorHandler(error));
    }
  };
}
export async function updateUserStatus(data) {
  try {
    const response = await axios(options(API_URL + "/admin/user_status_changed", data, "post"));
    const responseOK = response && response.status === 200 && response.statusText === "OK";
    if (responseOK) {
      toast_notifications.success(response.data.message);
    }
  } catch (error) {
    console.warn("Error:", error);
    // dispatch(errorHandler(error));
  }
}

export function updateRolePermissions(data) {
  return async (dispatch) => {
    try {
      const response = await axios(options(API_URL + "/role/permissions", { data }, "post"));
      const responseOK = response && response.status === 200 && response.statusText === "OK";
      if (responseOK) {
        return response.data;
      }
    } catch (error) {
      console.warn("Error:", error);
      dispatch(errorHandler(error));
    }
  };
}

export function getAllPermissions() {
  return async (dispatch) => {
    try {
      const response = await axios(options(API_URL + "/role/permissions", {}, "get"));
      const responseOK = response && response.status === 200 && response.statusText === "OK";
      if (responseOK) {
        return response.data;
      }
    } catch (error) {
      console.warn("Error:", error);
      dispatch(errorHandler(error));
    }
  };
}

export function deletRole(data) {
  return async (dispatch) => {
    try {
      const response = await axios(options(API_URL + "/admin/role", { data }, "delete"));
      const responseOK = response && response.status === 200 && response.statusText === "OK";
      if (responseOK) {
        toast_notifications.success("User role successfully deleted!");
      }
    } catch (error) {
      console.warn("Error:", error);
      dispatch(errorHandler(error));
    }
  };
}

export function copyRole(data) {
  return async (dispatch) => {
    try {
      const response = await axios(options(API_URL + "/admin/role/copy", { data }, "post"));
      const responseOK = response && response.status === 200 && response.statusText === "OK";
      if (responseOK) {
        toast_notifications.success("Copy of the role was successfully created!");
      }
    } catch (error) {
      console.warn("Error:", error);
      dispatch(errorHandler(error));
    }
  };
}

export function usersRoleCount(id) {
  return async (dispatch) => {
    try {
      const response = await axios(options(API_URL + `/admin/role/count/${id}`, {}, "get"));
      const responseOK = response && response.status === 200 && response.statusText === "OK";
      if (responseOK) {
        return response.data;
      }
    } catch (error) {
      console.warn("Error:", error);
      dispatch(errorHandler(error));
    }
  };
}

export function changeUsersRoleWithSingle(data) {
  return async (dispatch) => {
    try {
      const response = await axios(
        options(API_URL + `/admin/role/changeRole/single`, { data }, "post")
      );
      const responseOK = response && response.status === 200 && response.statusText === "OK";
      if (responseOK) {
        toast_notifications.success("All Users roles were successfully changed!");
        return response.data;
      }
    } catch (error) {
      console.warn("Error:", error);
      dispatch(errorHandler(error));
    }
  };
}

export function changeUsersRoleWithMultiple(data) {
  return async (dispatch) => {
    try {
      const response = await axios(
        options(API_URL + `/admin/role/changeRole/multiple`, { data }, "post")
      );
      const responseOK = response && response.status === 200 && response.statusText === "OK";
      if (responseOK) {
        toast_notifications.success("All Users roles were successfully changed!");
        return response.data;
      }
    } catch (error) {
      console.warn("Error:", error);
      dispatch(errorHandler(error));
    }
  };
}

export const adminServices = {
  // updateUserStatus: (data) => axios(options(API_URL + "/admin/user_status_changed", data, "post")),
  activateUser: (data) => axios(options(API_URL + "/admin/users/activate", data, "post")),
  deactivateUser: (data) => axios(options(API_URL + "/admin/users/deactivate", data, "post")),
  fetchUserActivation: (data) => axios(options(API_URL + "/admin/user_activation", data, "put")),
  deleteUser: (data) => axios(options(API_URL + "/admin/deleteUser", data, "post")),
  createUser: (body) => axios(options(API_URL + "/admin/user_create", body, "post")),
  getRoles: () => axios(options(API_URL + "/admin/role", {}, "get")),
  logOutUser: (data) => axios(options(API_URL + "/admin/log-out-user", data, "post")),
};
